<template>
  <div class="dougong-company-config">
    <el-alert
      type="warning"
      :closable="false"
      show-icon
      class="config-tip"
      title="公司级斗拱参数：SysId、RSA 密钥、ChannelNo、PayScene 全公司共用；经销商 HuifuId 请在各经销商「斗拱配置」中维护。"
    />
    <el-form ref="form" :model="form" :rules="rules" label-width="180px">
      <el-form-item label="SysId" prop="sys_id">
        <el-input v-model="form.sys_id" style="width: 500px" placeholder="汇付斗拱系统号（请求外层 sys_id，与 RSA 私钥配对）" />
      </el-form-item>
      <el-form-item label="商户 RSA 私钥" prop="rsa_private_key">
        <el-input
          v-model="form.rsa_private_key"
          type="textarea"
          :rows="10"
          style="width: 500px"
          maxlength="4096"
          show-word-limit
          placeholder="商户 RSA 私钥"
        />
      </el-form-item>
      <el-form-item label="汇付 RSA 公钥" prop="rsa_public_key">
        <el-input
          v-model="form.rsa_public_key"
          type="textarea"
          :rows="6"
          style="width: 500px"
          maxlength="1024"
          show-word-limit
          placeholder="汇付 RSA 公钥"
        />
      </el-form-item>
      <el-form-item label="签名方式" prop="sign_type">
        <el-select v-model="form.sign_type" style="width: 200px">
          <el-option label="RSA" value="RSA" />
        </el-select>
      </el-form-item>

      <el-divider content-position="left">支付场景（全公司共用）</el-divider>
      <el-form-item label="ChannelNo" prop="channel_no">
        <el-input v-model="form.channel_no" style="width: 500px" placeholder="自有渠道号" />
      </el-form-item>
      <el-form-item label="线下 PayScene" prop="offline_pay_scene">
        <el-input v-model="form.offline_pay_scene" style="width: 500px" placeholder="如 3（线下小程序）" />
      </el-form-item>
      <el-form-item label="线上 PayScene" prop="online_pay_scene">
        <el-input v-model="form.online_pay_scene" style="width: 500px" placeholder="如 5（线上小程序）" />
      </el-form-item>

      <el-divider content-position="left">以旧换新余额</el-divider>
      <el-form-item label="SysId" prop="tradein_out_huifu_id">
        <el-input
          v-model="form.tradein_out_huifu_id"
          style="width: 500px"
          placeholder="汇付斗拱系统号"
        />
      </el-form-item>
      <el-form-item label="ProductId" prop="tradein_product_id">
        <el-input
          v-model="form.tradein_product_id"
          style="width: 500px"
          placeholder="以旧换新余额 ProductId"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="saving" @click="saveConfig">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getDougongDetail, saveDougongFrom } from '@/api/trade'

export default {
  data () {
    return {
      saving: false,
      rules: {
        sys_id: [{ required: true, message: '请输入 SysId', trigger: 'blur' }],
        rsa_private_key: [{ required: true, message: '请输入商户 RSA 私钥', trigger: 'blur' }],
        rsa_public_key: [{ required: true, message: '请输入汇付 RSA 公钥', trigger: 'blur' }],
        tradein_out_huifu_id: [{ required: true, message: '请输入 SysId', trigger: 'blur' }],
        tradein_product_id: [{ required: true, message: '请输入以旧换新 ProductId', trigger: 'blur' }]
      },
      form: {
        sys_id: '',
        rsa_private_key: '',
        rsa_public_key: '',
        sign_type: 'RSA',
        channel_no: '',
        offline_pay_scene: '',
        online_pay_scene: '',
        tradein_out_huifu_id: '',
        tradein_product_id: ''
      }
    }
  },
  mounted () {
    this.loadConfig()
  },
  methods: {
    loadConfig () {
      getDougongDetail().then(res => {
        const data = res.data.data || {}
        this.form.sys_id = data.sys_id || ''
        this.form.rsa_private_key = data.rsa_private_key || ''
        this.form.rsa_public_key = data.rsa_public_key || ''
        this.form.sign_type = data.sign_type || 'RSA'
        this.form.channel_no = data.channel_no || ''
        this.form.offline_pay_scene = data.offline_pay_scene || ''
        this.form.online_pay_scene = data.online_pay_scene || ''
        this.form.tradein_out_huifu_id = data.tradein_out_huifu_id || ''
        this.form.tradein_product_id = data.tradein_product_id || ''
      }).catch(() => {})
    },
    saveConfig () {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        saveDougongFrom({ ...this.form }).then(res => {
          this.$message.success(res.data.message || '保存成功')
        }).finally(() => {
          this.saving = false
        })
      })
    }
  }
}
</script>
<style scoped lang="scss">
.dougong-company-config {
  .config-tip {
    margin-bottom: 16px;
  }
}
</style>
